<template>
  <div
    class="diary-table__rate"
    :class="cellClass"
    @mouseenter="toggleGradeModal($event, gradebook, true)"
    @mouseleave="toggleGradeModal($event, gradebook, false)"
  >
    <!-- если есть оценка  -->
    <span
      v-if="
        gradebook.rate
        && gradebook.rate.grade !== null
        && gradebook.rate.status !== 5
        && gradebook.rate.status !== 2
      "
    >
     <span v-if="gradebook.rate.lesson_grade_type === 2">
        <img
            :src="getSmile(gradebook.rate.grade)"
            class="width-img"
            alt="smile"
        />
      </span>

      <span v-else>{{ gradebook.rate.grade }}</span>
    </span>

    <!-- if orange-day -->
    <span v-if="gradebook.rate && gradebook.rate.status === 5">
      <img
        :src="env.public_base + '/assets/images/icon-was-ill.svg'"
        alt="medical"
      />
    </span>

    <!-- if yellow-day -->
    <span v-if="gradebook.rate && gradebook.rate.status === 2">
      <img
        :src="env.public_base + '/assets/images/icon-check-work.svg'"
        alt="check"
      />

    </span>
    <!-- if has meddoc -->
    <a
      v-if="
        gradebook.isSimple &&
        gradebook.rate &&
        gradebook.rate.med_docs[0]
      "
      :href="gradebook.rate.med_docs[0].doc_file"
      target="_blank"
      class="diary-table__med-link"
    ></a>

    <!-- if thematic grade -->
    <div
      v-if="!gradebook.isSimple"
      class="diary-table__grade-type">
        {{ gradeType }}
      </div>
  </div>
</template>

<script>
import env from '../../env';
import helpers from "../../helpers";

// const gradeStatuses = {
//   1: "new",
//   2: "checking",
//   3: "failed",
//   4: "passed",
//   5: "was_ill",
// };

export default {
  props: {
    gradebook: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      env,
    };
  },
  computed: {
    gradeType() {
      let type;

      switch (true) {
        case this.gradebook.isThematic:
          type = this.$t('grade_head.thematic');
          break;

        case this.gradebook.isSemester:
          type = this.gradebook.semester + this.$t('grade_head.semester');
          break;

        case this.gradebook.isYear:
          type = this.$t('grade_head.year');
          break;
      
        default:
          type = '';
          break;
      }

      return type;
    },
    cellClass() {
      const { rate, isBigerToday, isSimple } = this.gradebook;

      if (!isSimple) return null;

      const isNotRate = rate === undefined || rate === null;

      if (isBigerToday && isNotRate) return 'fiol-day';

      if (isNotRate) return null;

      const { grade, med_docs, status } = rate;

      const isNotGradeOrDoc = grade === null && med_docs[0] === undefined;

      if (isBigerToday && isNotGradeOrDoc && status === 1) {
        return 'fiol-day';
      }

      let cssClass;

      switch (status) {
        case 2:
          cssClass = 'yellow-day';
          break;

        case 3:
          cssClass = 'red-day';
          break;

        case 4:
          cssClass = 'green-day';
          break;

        case 5:
          cssClass = 'orange-day';
          break;

        case 6:
          cssClass = 'gray-day';
          break;
      
        default:
          cssClass = null;
          break;
      }

      return cssClass;
    },
  },
  methods: {
    toggleGradeModal(e, gradebook, show) {
      this.$emit('toggleGradeModal', { e, gradebook, show });
    },
    getSmile(grade) {
      return helpers.getSmile(grade);
    },
  },
};
</script>

<style lang="sass" scoped>
.diary-table__rate
  background-color: white
  min-width: 31px
  flex-shrink: 0
  font-weight: 700
  position: relative
  border-right: 1px solid #EEEEEE
  border-left: none !important

.diary-table__med-link,
.diary-table__lesson-link
  display: block
  width: 100%
  height: 100%
  position: absolute
  top: 0
  left: 0
  cursor: pointer

.diary-table__med-link
  z-index: 1

.diary-table__lesson-link
  z-index: 2

.diary-table__grade-type
  position: absolute
  bottom: 0
  right: 0
  padding: 2px 6px
</style>
